import { useEffect, useState } from "react"
import CloseButton from "../../../components/CloseButton/CloseButton"
import { useAppState } from "../../../context/appStateContext"
import { useBlackFriday } from "../../../context/blackFridayContext"
import usePromoCountdown from "../../../context/usePromoCountdown"
import native from "../../../native/native"
import useStrings from "../../../localization/useStrings"
import svg from "../../../utils/svg"
import styles from "./BlackFriday2025Banner.module.scss"

const BlackFriday2025Banner = () => {
  const blackFriday = useBlackFriday()
  const initialData = useAppState().state.initialData
  const { minutes, hours, seconds } = usePromoCountdown()
  const strings = useStrings()

  const isAlbumList = initialData?.source == "albumListTop"
  const closeVisible = isAlbumList

  const [visible, setVisible] = useState(false)

  // Calculate pricing
  const isUltimate =
    blackFriday.state.isUltimate ||
    blackFriday.state.isPremiumUser ||
    blackFriday.state.isUltimateLaunch

  const pricing = isUltimate
    ? blackFriday.state.ultimatePricing
    : blackFriday.state.premiumPricing
  const savingPercentage = pricing.savingPercent

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      className={`${styles.container} ${
        visible ? styles.fadeInShow : styles.fadeIn
      }`}
      onClick={() => blackFriday.actions.openPaywallFromBanner()}
    >
      {closeVisible && (
        <div onClick={(e) => e.stopPropagation()}>
          <CloseButton
            className={styles.close}
            onClick={() => native.postNativeEvent("close")}
            color="white"
          />
        </div>
      )}

      <div className={styles.header}>
        <div className={styles.countdown}>
          {hours.toString().padStart(2, "0")}h :{" "}
          {minutes.toString().padStart(2, "0")}m :{" "}
          {seconds.toString().padStart(2, "0")}s
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.iconContainer}>
          {isUltimate ? (
            <svg.UltimateIcon width={17} height={14} fill="#ffffff" />
          ) : (
            <svg.PremiumIcon width={17} height={19} fill="#ffffff" />
          )}
        </div>
        <label className={styles.title}>
          {strings.premiumToUltimateBlackFriday.bannerTitle(savingPercentage)}
        </label>
      </div>
    </div>
  )
}

export default BlackFriday2025Banner
